// author：jiana
// time:2024-06-12
// desc:本页面为方便快速构建vue文件模板基础页面搭建，在次基础上快速搭建

<template>
	<div class="rightNav">
		<div class="rightNavBox">
			<div :class="isShowCode?'xiazaiOne' : 'xiazai'" v-on:mouseenter="onMouseEnter" v-on:mouseleave="onMouseLeave">
				<i class="iconfont icon-erweima"></i>
				<div>APP下载</div>
			</div>
			<div :class="isShowFuwu?'fuwuOne':'fuwu'" v-on:mouseenter="onMouseEnterOne" v-on:mouseleave="onMouseLeave">
				<i class="iconfont icon-phone"></i>
				<div>服务热线</div>
			</div>
			<div :class="isShowYixiang?'yixiangOne':'yixiang'" v-on:mouseenter="onMouseEnterTwo" v-on:mouseleave="onMouseLeave" @click="goYixiang">
				<i class="iconfont icon-cooperation"></i>
				<div>意向合作</div>
			</div>
		</div>
		<div class="backTop" @click="goBack">
			<i class="iconfont icon-jiantou-copy-copy-copy"></i>
		</div>
		<div class="codeBox" v-show="isShowCode">
			<img src="../../assets/imgs/app.svg" alt="" class="codeImg">
			<div>扫码下载爱养牛APP</div>
		</div>
		<div class="phoneBox" v-show="isShowFuwu">
			<div>服务热线</div>
			<div class="phoneColor">0471-4599633</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'rightNav',
	components: {

	},
	props:{
		
	},
	data() {
		return {
			isShowCode:false,
			isShowFuwu:false,
			isShowYixiang:false
		}
	},
	computed: {

	},
	methods: {
		onMouseEnter() {
			// 鼠标进入元素时的处理逻辑
			console.log('鼠标进入');
			this.isShowCode = true
			this.isShowFuwu = false
			this.isShowYixiang = false
		},
		onMouseLeave() {
			// 鼠标离开元素时的处理逻辑
			console.log('鼠标离开');
			this.isShowCode = false
			this.isShowFuwu = false
			this.isShowYixiang = false
		},
		onMouseEnterOne(){
			this.isShowCode = false
			this.isShowFuwu = true
			this.isShowYixiang = false
		},
		onMouseEnterTwo(){
			this.isShowCode = false
			this.isShowFuwu = false
			this.isShowYixiang = true
		},
		goBack(){
			this.$emit("goBack",true)
		},
		goYixiang(){
			this.$jump('/cooperation')
		}
	},

	mounted() {
		console.log(this.$route.path,'this.$route.path')
	},

	watch: {

	}
}
</script>

<style lang="less" scoped>
.rightNav{
	.rightNavBox{
		width: 40px;
		height: 190px;
		padding: 8px;
		text-align: center;
		cursor: pointer;
		box-sizing: border-box;
		border: 2px solid rgb(255, 255, 255);
		border-radius: 20px;
		box-shadow: 0px 0px 10px 0px rgb(240, 242, 247);
		background: linear-gradient(149.89deg, rgb(245, 246, 249) 0.487%,rgb(255, 255, 255) 99.472%);
	}
	.codeBox{
		position: fixed;
		top: 50vh;
		right: 60px;
		width: 90px;
		height: 100px;
		box-sizing: border-box;
		text-align: center;
		padding-top: 5px;
		border: 2px solid rgb(255, 255, 255);
		border-radius: 1px;
		box-shadow: 0px 0px 10px 0px rgb(240, 242, 247);
		background: linear-gradient(180.00deg, rgb(245, 246, 249),rgb(255, 255, 255) 100%);

	}
	.codeImg{
		width: 75px;
		height: 75px;
	}
	.fuwu{
		border-top: 1PX solid #eee;
		border-bottom: 1PX solid #eee;
		padding: 5px 0;
		color: #999;
	}
	.fuwuOne{
		border-top: 1PX solid #eee;
		border-bottom: 1PX solid #eee;
		padding: 5px 0;
		color: #2986FF;
	}
	.xiazai{
		margin-bottom: 5px;
		color: #999;
	}
	.xiazaiOne{
		margin-bottom: 5px;
		color: #2986FF;
	}
	.yixiang{
		margin-top: 5px;
		color: #999;
	}
	.yixiangOne{
		margin-top: 5px;
		color: #2986FF;
	}
	.backTop{
		width: 40px;
		height: 40px;
		margin-top: 5px;
		text-align: center;
		line-height: 40px;
		color: #999;
		cursor: pointer;
		border-radius: 40px;
		box-sizing: border-box;
		border: 2px solid rgb(255, 255, 255);
		box-shadow: 0px 0px 10px 0px rgb(240, 242, 247);
		background: linear-gradient(149.74deg, rgb(245, 246, 249) 17.846%,rgb(255, 255, 255) 89.239%);
	}
	.phoneBox{
		position: fixed;
		top: 62vh;
		right: 60px;
		width: 80px;
		height: 40px;
		padding: 5px;
		box-sizing: border-box;
		border: 2px solid rgb(255, 255, 255);
		box-shadow: 0px 0px 10px 0px rgb(240, 242, 247);
		background: linear-gradient(180.00deg, rgb(245, 246, 249),rgb(255, 255, 255) 100%);
	}
	.phoneColor{
		color: #2986FF;
		margin-top: 5px;
	}
}
</style>
<style scolang="less">
.rightNav{
	
}
</style>